import EmbeddedTreebank from './EmbeddedTreebank';

export default EmbeddedTreebank;
